module.exports = __webpack_public_path__ + "img/dia_das_maes.417e1cfd.svg";